import "./EditBlackMasks.html";
import "./EditBlackMasks.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditBlackMasksComponentController from "./EditBlackMasksComponentController";

export default class EditBlackMasksComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            image: "<",
            masks: "=",
            isEditable: "<",
        };
        this.controller = EditBlackMasksComponentController;
        this.templateUrl =
            "/App/Components/Site/DesignAndPlanning/" +
            "SelectedEquipment/CameraConfigurations/EditVideoStream/EditBlackMasks/EditBlackMasks.html";
    }
}

module("mmManagePortal").component("irEditBlackMasks", new EditBlackMasksComponent());
